<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Multiselect from 'vue-multiselect'

export default {

	page: {
		title: 'Пополнение счета',
		meta: [{ name: 'description', content: appConfig.description }],
	},

	components: { Layout, PageHeader, Multiselect },

	data() {

        return {
			title: 'Пополнение счета',
			items: [],
            finance_uuid: null,
            document_uuid: null,
            trackBy: 'id',

            type: null,
            types_options: [],
            initType: [],

            status: '',
            status_options: [
                { id:'wait', name:'Ожидается оплата' },
                { id:'processing', name:'Обработка' },
                { id:'blocked', name:'Заблокирована' },
                { id:'canceled', name:'Отмена' },
                { id:'error', name:'Ошибка' },
                { id:'success', name:'Оплачено' },
            ],
            initStatus: [],

            company_id: null,

            account_id: null,
            account: null,
            initAccount: [],
            account_options: [],

            sum: null,
            vat_sum: 0, 
            isAdmin: false,
            isCompany: false,

            isSubmitError: null,
            alertMessage: null,
            alertVariant: null,
        }
	},

    watch: {
        account: {
            immediate: true,
            handler(values) {
                if(this.account && this.account.company_id){
                    this.types_options = [
                        { id:'invoice',  name:'Счет на оплату' },
                        { id:'bankcard', name:'Банковская карта' },
                    ];
                } else {
                    this.types_options = [
                        { id:'bankcard', name:'Банковская карта' },
                    ];
                }
                if(this.session_user_item.role === 'administrator'){
                    this.types_options = [
                        { id:'invoice',  name:'Счет на оплату' },
                        { id:'bankcard', name:'Банковская карта' },
                        { id:'manual',   name:'Ручное пополнение' },
                    ];
                }
            }
        },
        initType: {
            immediate: true,
            handler(values) {
                this.type = this.types_options.filter(x => values.includes(x[this.trackBy]));
                this.type = this.type[0];
            }
        },
        initAccount: {
            immediate: true,
            handler(values) {
                this.account = this.account_options.filter(x => values.includes(x[this.trackBy]));
                this.account = this.account[0];
            }
        },
        initStatus: {
            immediate: true,
            handler(values) {
                this.status = this.status_options.filter(x => values.includes(x[this.trackBy]));
                this.status = this.status[0];
            }
        },
        sum: {
            immediate: true,
            handler(values) {
                this.vat_sum = this.sum * 0.05;
            }
        },
    },

	computed: {
        documents_item(){
            return this.$store.getters['documents/GET_DOCUMENTS_ITEM'];
        },
        accounts_list_data(){
            return this.$store.getters['accounts/GET_ACCOUNTS_LIST_DATA'];
        },
        session_user_item(){
            let session = this.$store.getters['sessions/GET_SESSIONS_ITEM'];
            return session.user ? session.user : null;
        },
	},

	async mounted() {

        if(this.session_user_item && this.session_user_item.role == 'administrator'){
            this.isAdmin = 'true';
        }

	    this.document_uuid = this.$route.params.document_uuid ? this.$route.params.document_uuid : null;

        await this.$store.dispatch('accounts/FETCH_ACCOUNTS_LIST', {'limit': 5000});
        this.account_options = this.accounts_list_data;

        if(this.document_uuid !== null){

            let data_send = {
                'uuid' : this.document_uuid,
            }

            await this.$store.dispatch('documents/FETCH_DOCUMENTS_ITEM', data_send);

            let document = this.documents_item;

            this.account_id   = document.account_id ? document.account_id : null;
            this.company_id   = document.company_id ? document.company_id : null;
            this.user_id      = document.user_id ? document.user_id : null;
            this.type         = document.type ? document.type : null;
            this.status       = document.finance && document.finance.status ? document.finance.status : null;
            this.sum          = document.sum ? document.sum : null;
            this.finance_uuid = document.finance && document.finance.uuid ? document.finance.uuid : null;

            if(this.company_id){
                this.types_options = [
                    { id:'invoice',  name:'Счет на оплату' },
                    { id:'bankcard', name:'Банковская карта' },
                ];
            } else {
                this.types_options = [
                    { id:'bankcard', name:'Банковская карта' },
                ];
            }
            if(this.session_user_item.role === 'administrator'){
                this.types_options = [
                    { id:'invoice',  name:'Счет на оплату' },
                    { id:'bankcard', name:'Банковская карта' },
                    { id:'manual',   name:'Ручное пополнение' },
                ];
            }

            if(this.account_id) this.initAccount = [this.account_id];
            if(this.type) this.initType = [this.type];
            if(this.status) this.initStatus = [this.status];

        }
	},

	methods: {
        async savePayment(){

            let error = false
            let alertMessage = '';

            if(this.type === null || !this.type || !this.type.id ){
                alertMessage = 'Укажите способ оплаты.';
                error = true;
            }

            if(this.account === null || !this.account || !this.account.id){
                if(alertMessage !== ''){
                    alertMessage = alertMessage + ' '
                }
                alertMessage = alertMessage + 'Необходимо заполнить поле Аккаунт.';
                error = true;
            }

            if(this.sum === null){
                if(alertMessage !== ''){
                    alertMessage = alertMessage + ' '
                }
                alertMessage = alertMessage+ 'Поле сумма не может быть пустым.';
                error = true;
            }

            if(error === true){

                this.isSubmitError = true;
                this.alertMessage  = alertMessage;
                this.alertVariant  = 'danger';

            } else {

                let document_type = null;
                let method = this.type && this.type.id ? this.type.id : null;

                if (method === 'bankcard') {
                    document_type = 'cheque';
                }
                if (method === 'invoice') {
                    document_type = 'invoice';
                }
                
                let result = '';
                let name = '';

                let data_send = {
                        'company_id' : this.account && this.account.company_id ? this.account.company_id : null,
                        'account_id' : this.account && this.account.id ? this.account.id : null,
                        'user_id'    : this.account && this.account.user_id ? this.account.user_id : null,
                        'type'       : document_type,
                        'status'     : this.status ? this.status.id : null,
                        'sum'        : this.sum ? this.sum : null
                    };

                if(document_type !== null){
                    if (method === 'invoice') {
                        name = 'Счет на оплату';
                    }

                    data_send.name = name;

                    if (this.document_uuid === null) {
                        result = await this.$store.dispatch('documents/FETCH_DOCUMENTS_CREATE', data_send);
                    } else {
                        data_send.uuid = this.document_uuid;
                        result = await this.$store.dispatch('documents/FETCH_DOCUMENTS_UPDATE', data_send);
                    }
                }
            

                if (result === false) {
                    alert('Возникла ошибка');
                } else {

                    // Создаем финансовую транзакцию
                    data_send.document_id = result && result.id ? result.id : null;
                    let comments = '';

                    if (method === 'invoice') {
                        comments = 'Оплата по счету №' + result.number;
                    }  
                    
                    if (method === 'bankcard'){
                        comments = 'Пополнение счета';
                        data_send.gate = 'true';
                    }

                    if (method === 'manual'){
                        comments = 'Пополнение счета';
                    }

                    data_send.pay_method = method;
                    data_send.comments = comments;
                    data_send.type = 'payin';

                    let redirect_url = null;

                    if (this.finance_uuid === null) {
                        
                        let new_finance = await this.$store.dispatch('finance/FETCH_FINANCE_CREATE', data_send);

                        if (this.type.id && this.type.id === 'bankcard') {

                            data_send = {
                                'finance_uuid': new_finance.uuid
                            }

                            /* Создаем транзакцию в платежной системе */
                            let payment_result = await this.$store.dispatch('payments/FETCH_PAYMENTS_CREATE', data_send);
                            console.log(payment_result);

                            /* Переходим на платежную страницу */
                            if (payment_result.redirect_url && payment_result.redirect_url !== '') {
                                redirect_url = payment_result.redirect_url;
                                window.location.href = redirect_url;
                            }
                        }
                    } else {
                        data_send.uuid = this.finance_uuid;
                        result = await this.$store.dispatch('finance/FETCH_FINANCE_UPDATE', data_send);
                    }

                    if (result === false) {
                        alert('Возникла ошибка');
                    } else {
                        // if (redirect_url === null) {
                        //     if (this.type === 'invoice') {
                        //         this.$router.push({name: 'Documents'});
                        //     } else {
                        //         this.$router.push({name: 'Finance', params: {type : 'payin'}});
                        //     }
                        // }
                    }
                }
            }
        }
	},
}

</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />
        <b-form
            class="form-horizontal"
            @submit.prevent="savePayment"
        >
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">

                        <b-alert
                            v-model="isSubmitError"
                            :variant="alertVariant"
                            dismissible
                        >{{ alertMessage }}</b-alert
                        >
                            <div class="row">
                                <div class="col">

                                    <b-form-group
                                        label="Аккаунт клиента"
                                        label-for="account"
                                    >
                                        <multiselect
                                            id="account"
                                            :track-by="trackBy"
                                            v-model="account"
                                            :options="account_options"
                                            placeholder="Выберите из списка"
                                            selectLabel="Нажмите, чтобы выбрать"
                                            deselectLabel="Нажмите, снять выделение"
                                            label="name"
                                        ></multiselect>
                                    </b-form-group>

                                    <b-form-group
                                        label="Способ оплаты"
                                        label-for="type"
                                    >
                                        <multiselect
                                            id="type"
                                            v-model="type"
                                            :options="types_options"
                                            placeholder="Выберите из списка"
                                            selectLabel="Нажмите, чтобы выбрать"
                                            deselectLabel="Нажмите, снять выделение"
                                            label="name"
                                            :track-by="trackBy"
                                        ></multiselect>
                                    </b-form-group>

                                    <b-form-group
                                        label="Сумма, руб."
                                        label-for="input-horizontal"
                                    >
                                        <b-form-input
                                            id="sum"
                                            v-model="sum"
                                        ></b-form-input>
                                    </b-form-group>
                                    <p>В том числе НДС - 5%: {{ vat_sum }} руб.</p>
                                    <b-form-group
                                        label="Статус"
                                        label-for="status"
                                        v-show="isAdmin"
                                    >
                                        <multiselect
                                            id="status"
                                            v-model="status"
                                            :options="status_options"
                                            placeholder="Выберите из списка"
                                            selectLabel="Нажмите, чтобы выбрать"
                                            deselectLabel="Нажмите, снять выделение"
                                            label="name"
                                            :track-by="trackBy"
                                        ></multiselect>
                                    </b-form-group>

                                    <p>После нажатия кнопки "Продолжить", вы перейдете на защищенную страницу процессингового центра банка ЮКаssa, а также подтверждаете, что ознакомлены и согласны с <a href="https://za-bota.com/payment_rules.pdf" target="_blank">правилами оплаты и безопасности платежей</a></p>
                                    
                                </div>
                            </div>
                    </div>
                    <hr style="margin-bottom: 0px !important; margin-top: 0px !important">
                    <div style="padding: 0.75rem">
                        <button type="submit" class="btn btn-primary">Сохранить</button>
                    </div>
                    <!-- end card-body -->
                </div>
                <!-- end card-->
            </div>
            <!-- end col -->
        </div>
        </b-form>
	</Layout>
</template>
